<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>
        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>
 
    <div class="topbar-end">
        <ul class="topbar-menu">
           
            <li class="ml-3">
                {{globalservice.fullName}}
            </li>
            <li class="topbar-profile">
                <span style="height: 30px;
                width: 30px;
                cursor:pointer;
                background-color: var(--primary-color);
                border-radius: 50%;
                color:#FFF;
                text-align: center;
                padding-top: 3px;
                display: inline-block;"
                (click)="onProfileButtonClick()">{{globalservice.userInitials}}</span>

            </li>
        </ul>
    </div>
</div>